import React, { useState, useEffect } from 'react';
import HomeTwoAbout from './HomeTwoAbout/HomeTwoAbout';
import HomeTwoAppoinmentArea from './HomeTwoAppoinmentArea/HomeTwoAppoinmentArea';
import HomeTwoBlogs from './HomeTwoBlogs/HomeTwoBlogs';
import HomeTwoCounter from './HomeTwoCounter/HomeTwoCounter';
import HomeTwoFooter from './HomeTwoFooter/HomeTwoFooter';
import HomeTwoHeroSection from './HomeTwoHeader/HomeTwoHeroSection';
import HomeTwoMissionArea from './HomeTwoMissionArea/HomeTwoMissionArea';
import HomeTwoNavBar from './HomeTwoNavBar/HomeTwoNavBar';
import HomeTwoServicesArea from './HomeTwoServicesArea/HomeTwoServicesArea';
import SEOHead from '../../components/SEO/SEOHead';
import { useTranslation } from 'react-i18next';

const HomeTwo = () => {
    const [isVisible, setIsVisible] = useState(false);
    const { i18n } = useTranslation();
    const description = i18n.language === 'en'
        ? 'Attain a naturally elegant and beautiful appearance with filler, thread lifting, mesotherapy, healthy living support, and medical dermatology treatments in Ankara.'
        : 'Yaşınızın çok daha iyisi olmak için dolgu, iple yüz germe, mezoterapi, sağlıklı yaşam ve medikal dermatoloji uygulamalarıyla doğal ve zarif sonuçlar elde edin.';

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 30) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <>
            <SEOHead
                title={i18n.language === 'en' ? 'Assoc. Prof. Dr. Ebru Karagün | Ankara Dermatology Clinic' : 'Doç. Dr. Ebru Karagün | Ankara Dermatoloji Kliniği'}
                description={description}
                image="/img/about/drebrukaragun.jpg"
                imageAlt={i18n.language === 'en'
                    ? 'Portrait of Assoc. Prof. Dr. Ebru Karagün'
                    : 'Doç. Dr. Ebru Karagün portre fotografi'}
                trPath="/"
                enPath="/en/"
            />
            <HomeTwoNavBar />
            {isVisible && <a
                href="https://wa.me/905332691271"
                className={`whatsapp_float`}
                target="_blank"
                rel="noopener noreferrer"
            >
                <button
                    className="play-btn popup-video"><i className="fab fa-whatsapp whatsapp-icon"></i>
                </button>

            </a>}
            <HomeTwoHeroSection />
            <HomeTwoAbout />
            <HomeTwoMissionArea />
            <HomeTwoServicesArea />
            <HomeTwoCounter />
            <HomeTwoAppoinmentArea />
            <HomeTwoBlogs />
            <HomeTwoFooter />
        </>
    );
};

export default HomeTwo;
